import { useApi } from '../useApi'
// eslint-disable-next-line import/no-unresolved
import { getCmsStorelocators } from 'data-api'

export const useStoreLocatorStores = ({ sku, fields, where, order, limit, offset, skip, options } = {}) => {
	const { data, error, isValidating, mutate, cancel, cancelled } = useApi({
		method: getCmsStorelocators,
		args: {
			sku,
			fields,
			where,
			order,
			limit,
			offset,
			skip,
		},
		options,
	})

	return {
		stores: data,
		loading: isValidating,
		error,
		mutate,
		cancel,
		cancelled,
	}
}
